<template>
    <dashboard-layout>

        <div class="row">
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{errorMessage}}
          </div>

<!-- Area Chart -->
<div class="col-md-6">
        <router-link to="/dashboard" class="icon text-gray-600" style="padding-left: 30px;">
        <i class="fas fa-arrow-left"></i> Back
        </router-link>
    </div>
<div class="col-xl-8 col-lg-7" style="padding: 40px;">

    
    <div class="card shadow mb-4">
        <!-- Card Header - Dropdown -->
        <div
            class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
            <h6 class="m-0 font-weight-bold text-dark">Netpay Actions Items</h6>
        </div>
        <!-- Card Body -->
        <div class="card-body">
            <div class="chart-area">


                <div class="custom-card">
              <router-link  to="/settlement">
            <div class="card-header custom-shadow card border-left-success btn-light">
                <span class="items-text">Settlement Reprocess</span>
           </div>
            </router-link>
            <br>
            <router-link  to="/bulksettlement">
            <div class="card-header custom-shadow card border-left-success btn-light">
                <span class="items-text">Bulk Settlement Reprocess</span>
            </div>
          </router-link>
            <br>

            <router-link  to="/view-transactions">
            <div class="card-header custom-shadow card border-left-success btn-light">
                <span class="items-text">View Reprocessed Transactions</span>
            </div>
          </router-link>
            </div>
            </div>
        </div>
    </div>
</div>

<!-- Netpay Settlement Status -->
<div class="col-xl-4 col-lg-5 " style="padding: 20px;"><br>
  
    <div class="card shadow mb-4">
        <!-- Card Header - Dropdown -->
        <div
            class="card-header py-3 d-flex flex-row align-items-center justify-content-center">
            <h6 class="m-0 font-weight-bold text-dark">Netpay Settlement Status</h6>
            
        </div>
        <!-- Card Body -->
        <div class="card-body d-flex flex-column align-items-center justify-content-center">
            <div v-if="showSuccessMessage" class="alert alert-success" role="alert">
            Settlement Started Successfully
          </div>
          
          <div v-if="isLoading" class="text-center">
            <i class="fas fa-spinner fa-spin fa-3x"></i> <!-- Loading icon -->
            <p>Loading...</p>
          </div>
          <div v-else>
            <div class="chart-pie pt-4 pb-2 d-flex align-items-center justify-content-center">
                <a
                class="btn custom-button btn-circle"
                :class="statusClass"
                :disabled="status == 1 || clicked"
                @click="restartService"
                >
              <span class="running-text">{{ statusText }}</span>
            </a>
          </div>
        </div>



            <div class="mt-4 text-center small">
                <span class="mr-2">
                    <i class="fas fa-circle text-success"></i> Running
                </span>
                <span class="mr-2">
                    <i class="fas fa-circle text-danger"></i> Stopped
                </span>
            </div>
            
        </div>
    </div>
</div>


</div>
      
    </dashboard-layout>
  </template>
  
  <script>
  import axios from 'axios';
  import DashboardLayout from '@/components/DashboardLayout.vue';


let logData;


  
  export default {
    name: 'netpay-page',
  
    components: {
      DashboardLayout,
    },
  
    data() {
      return {
        status: 0,
        showSuccessMessage: false,
        errorMessage: '',
        isLoading: true,
        clicked: false,
      };
    },
  
    computed: {
      statusClass() {
        return this.status == 1 ? 'btn-success' : 'btn-danger';
      },
      statusText() {
        return this.status == 1 ? 'Running' : 'Stopped';
      },
    },
  
    async created() {
      try{
     // Show the loading spinner
    this.isLoading = true;

      const token = sessionStorage.getItem('token');

      if (token) {
        await this.fetchStatus(token);
      }

// Hide the loading spinner once the status is fetched
this.isLoading = false;
      }catch (error) {
          console.error(error);
          this.isLoading = false;
          this.$toast.open({
          message: error,
          type: 'error',
          duration: 3000,
          });
          }
    },
  
    methods: {
      async fetchStatus() {
        const token = sessionStorage.getItem('token');
        try {
          const response = await axios.get(this.$config.GETSETTELEMTSTATUS_ENDPOINT,
          {
            headers: {
              Authorization: `Bearer ${token}`
          },
          }
          );
          this.status = response.data[0];
          
          
        } catch (error) {
          console.error(error);
          this.$toast.open({
          message: error,
          type: 'error',
          duration: 3000,
          });
        }
      },

      async restartService() {
        const token = sessionStorage.getItem('token');
        console.log('Restart button clicked');
      if (this.status == 0 && !this.clicked) {
        try {
          const headers = {
              'Authorization': `Bearer ${token}`,
            };
                    const response = await axios.post(this.$config.RESTARTSETTLEMENT_ENDPOINT, null, { headers: headers });
    
        if (response.status == 200) {

          logData = {
  UserID: sessionStorage.getItem('userId'),
  FName: sessionStorage.getItem('firstName'),
  LName: sessionStorage.getItem('lastName'),
  Email: sessionStorage.getItem('email'),
  Role: sessionStorage.getItem('role'),
  Department: sessionStorage.getItem('department'),
  ActionType: 'Settlement Restart',
  Activity: `Netpay Settlement has been restarted successfully`,
  Category: 'Netpay',
  Timestamp: new Date().toISOString()
};

const token = sessionStorage.getItem('token');
const headers = {
  'Authorization': `Bearer ${token}`,
};


axios.post(this.$config.ADDACTIVITYLOG_ENDPOINT, logData, { headers })
  .then(response => {
  
    console.log(response);
  })
  .catch(error => {
   
    console.error(error);
    this.$toast.open({
        message: error,
        type: 'error', 
        duration: 3000, 
      });
  });

  
  this.$toast.open({
        message: `Netpay Settlement has been restarted successfully, please check back in few minutes`,
        type: 'success', 
        duration: 3000, 
      });
        } else {
          this.$toast.open({
        message: `An error occured while restarting settlement, please contact the system administrator`,
        type: 'warning', 
        duration: 3000, 
      });
        }
        setTimeout(() => {
     this.showSuccessMessage = false;
     this.clicked = true;
    }, 2000);  
        } catch (error) {
          this.$toast.open({
        message: `An error occured while restarting settlement, please contact the system administrator`,
        type: 'warning',
        duration: 3000, 
      });
        }
      }
    },
    },
  };
  </script>
  
  <style>

.custom-card {
  margin: 10px;
}

.custom-button {
  width: 150px; 
  height: 150px; 
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5); 
}

.running-text {
  font-size: 16px; 
  font-weight: bold;
}

.custom-shadow{
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5); 
}

.items-text {
  font-size: 16px; 
  font-weight: bold;
  color: black;
}



  </style>
  